const createApiEnvironment = () => {
  const apiUrl = window._env_.REACT_APP_API_URL;
  const apiVersion = window._env_.REACT_APP_API_VERSION;

  return {
    apiUrl,
    apiVersion,
  };
};

const createNodeEnvironment = () => {
  const nodeEnv = window._env_.REACT_APP_NODE_ENV;

  return {
    nodeEnv,
  };
};

const createEnvironment = () => {
  const api = createApiEnvironment();
  const node = createNodeEnvironment();

  return {
    api,
	node
  };
};

export const environment = createEnvironment;
